<template>
  <div :id="this.$route.name">
    <card back>
      <template v-slot:header>
        <h4 class="d-inline">چاپ فیش های حقوقی</h4>
        <hr />
      </template>
      <template v-slot:btnCustome>
        <button class="btn btn-sm btn-info float-left" @click="GetAllFishStimul()">چاپ گروهی فیش ها</button>
        <!-- <button class="btn btn-sm btn-info float-left" @click="GetAllFish()">چاپ گروهی فیش ها</button> -->
      </template>
      <template v-slot:content>
        <div class="row"></div>
        <BnpGrid v-if="$store.state.renderComponentGrid" :excel="true" :propsColumn="Column" :propsRows="rows" :action="true" :hasRowNum="true" :Sortable="true" :SumList="['TotalPayment', 'DeductionsSum', 'NetPayment']">
          <template slot="action-slot" slot-scope="props">
            <button class="btn btn-sm btn-success" @click="GetFishStimul(props.props)">فیش حقوقی</button>
            <!-- <button class="btn btn-sm btn-success" @click="GetFish(props.props)">فیش حقوقی</button> -->
          </template>
        </BnpGrid>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  data() {
    return {
      rows: [],
      Column: [
        {
          name: 'Id',
          label: 'Id',
          visibility: false,
        },
        {
          name: 'NamFam',
          label: 'نام نام خانوادگی',
          visibility: true,
        },
        {
          name: 'PersonnelCode',
          label: 'کد پرسنلی',
          visibility: true,
        },
        {
          name: 'NationalCode',
          label: 'کد ملی',
          visibility: true,
        },
        {
          name: 'WorkPerformanceDaily',
          label: 'کارکرد',
          visibility: true,
        },
        {
          name: 'TotalPayment',
          label: 'پرداختی',
          visibility: true,
        },
        {
          name: 'DeductionsSum',
          label: 'کسورات',
          visibility: true,
        },
        {
          name: 'NetPayment',
          label: 'خالص پرداختی',
          visibility: true,
        },
      ],
      SalaryId: 0,
    }
  },
  components: { Card, BnpGrid },
  beforeMount() {
    this.SalaryId = this.$route.query.SalaryId
  },
  mounted() {
    this.GetData()
  },
  methods: {
    GetData() {
      var DataAxois = {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'SalaryReport/GetPersonelFish/' + this.SalaryId,
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxois)
        .then((data) => {
          if (data != null) {
            if (data.IsSuccess == true) {
              for (let index = 0; index < data.Data.SalaryDetails.length; index++) {
                const element = data.Data.SalaryDetails[index]
                this.rows.push(element)
              }
            }
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    GetFishStimul(data) {
      var LogoAddress = this.$cookies.get('URL') + this.$session.get('CompanyLogo')

      var DataAxios = { Method: 'POST', Action: 'ReportBuilder/SingleSalaryStimulPrint?tblSalaryDeatilId=', ArryfildValue: { Id: data.Id, Address: LogoAddress } }
      this.$PostData(DataAxios).then((result) => {
        if (result.status == 'succes') {
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.style = 'display: none'
          var url = this.$cookies.get('URL') + result.link
          a.href = url
          a.target = '_blank'

          a.download = result.link.split('\\')[1]
          a.click()
          window.URL.revokeObjectURL(url)
        }
      })
    },
    GetAllFishStimul() {
      /*      var DataAxois = {
      ArryfildValue: {},
      Method: 'Get',
      Action: 'SalaryReport/GetAllFish/' + this.SalaryId,
      Token: this.$session.get('Token'),

      }
      this.$PostData(DataAxois).then((data) => {
        if (data != null) {
          if (data.IsSuccess == true && data.Data != null) {
            console.warn(data.Data)

            this.$router.push({ name: 'FishPrint', params: { DataRow: data.Data, Status: 'All' } })
          }
        }
      })
      */
      var LogoAddress = this.$cookies.get('URL') + this.$session.get('CompanyLogo')

      var DataAxios = { Method: 'POST', Action: 'ReportBuilder/SalaryStimulPrint?tblSalaryId=', ArryfildValue: { Id: this.SalaryId, Address: LogoAddress } }
      this.$PostData(DataAxios).then((result) => {
        if (result.status == 'succes') {
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.style = 'display: none'
          var url = this.$cookies.get('URL') + result.link
          a.href = url
          a.target = '_blank'
          console.warn(url)
          a.download = result.link.split('\\')[1]
          a.click()
          window.URL.revokeObjectURL(url)
        }
      })
    },
    GetFish(data) {
      var DataAxois = {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'SalaryReport/GetFish/' + data.Id,
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxois).then((data) => {
        if (data != null) {
          if (data.IsSuccess == true && data.Data != null) {
            this.$router.push({ name: 'FishPrint', params: { DataRow: data.Data, Status: 'Single' } })
          }
        }
      })
    },
    GetAllFish() {
      var DataAxois = {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'SalaryReport/GetAllFish/' + this.SalaryId,
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxois).then((data) => {
        if (data != null) {
          if (data.IsSuccess == true && data.Data != null) {
            this.$router.push({ name: 'FishPrint', params: { DataRow: data.Data, Status: 'All' } })
          }
        }
      })
    },
  },
}
</script>
<style scoped></style>
